import $ from 'jquery';

export default {
    sticky (start, end, top) {
        const $this = this;
        const $window = $(window);

        start   = start || 0;
        end     = end || 1000000;
        top     = top || $this.offset().top;

        function toggle () {
            if ($window.scrollTop() < start) {
                $this.css({
                    position: 'absolute',
                    top: start
                });
            } else if ($window.scrollTop() > end - $this.height()) {
                $this.css({
                    position: 'absolute',
                    top: end - $this.height()
                });
            } else {
                $this.css({
                    position: 'fixed',
                    top
                });
            }
        }

        toggle();
        $window.scroll(toggle);
    },

    follow (startFn, endFn, pauseFn) {
        const $this   = this;
        const $window = $(window);
        const scrollY = $window.scrollTop();
        const eHeight = $this.height();
        const start   = (typeof startFn === 'function') ? startFn(this) : startFn || 0;
        const end     = (typeof endFn === 'function') ? endFn(this) : endFn || 1000000;

        pauseFn = pauseFn || (() => false);

        if (pauseFn($this, start, end))
            return false;

        if (scrollY > end - eHeight) {
            $this.css({transform: `translateY(${end - eHeight}px)`});
        } else if (scrollY < start) {
            $this.css({transform: `translateY(${start}px)`});
        } else {
            $this.css({transform: `translateY(${scrollY}px)`});
        }
    },

    animateFollow (duration, startFn, endFn, pauseFn) {
        let begin = null;
        const $this = this;

        duration = duration || 400;

        function animation(timestamp){
            if (!begin) begin = timestamp;

            const progress = timestamp - begin;

            $this.follow(startFn, endFn, pauseFn);

            if (progress >= duration) {
                window.cancelAnimationFrame(animation);
                return;
            }

            window.requestAnimationFrame(animation);
        }
        requestAnimationFrame(animation); // call requestAnimationFrame and pass into it animation function
    },

    stickyFollow (startFn, endFn, pauseFn) {
        const $this   = this;
        const $window = $(window);

        $this.follow(startFn, endFn, pauseFn);
        $window.scroll(() => {
            $this.follow(startFn, endFn, pauseFn);
        });
    }
};